import { React, useState } from "react";
import { createUser } from "../requests";
import { Redirect } from "react-router-dom";

export const CreateAccount = () => {
  const [error, setError] = useState(false);
  const [account, setAccount] = useState({
    email: "",
    password: "",
    cpassword: "",
    firstname: "",
  });

  const checkFieldNotEmpty = (input) => {
    if (
      input &&
      input.email !== "" &&
      input.password !== "" &&
      input.cpassword !== "" &&
      input.firstname !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkEmail = (input) => {
    var validRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (input && input.email && validRegex.test(input.email)) {
      return true;
    } else {
      return false;
    }
  };

  const checkPass = (input) => {
    if (input && input.password === input.cpassword) {
      return true;
    } else {
      return false;
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const stateAccount = { ...account, [e.target.name]: e.target.value };
    setAccount(stateAccount);
  };

  const fetchAccount = async () => {
    try {
      delete account.cpassword;
      const accountInput = await createUser(account);
      setAccount(accountInput);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    checkFieldNotEmpty(account) === true &&
    checkEmail(account) === true &&
    checkPass(account) === true
      ? setError(false)
      : setError(true);
    // temps de chargement !
    if (
      checkFieldNotEmpty(account) === true &&
      checkEmail(account) === true &&
      checkPass(account) === true
    ) {
      console.log("error", error);
      fetchAccount();
      alert("Merci pour la création de votre compte !");
      return Redirect("/login");
    }
  };

  const handleResetForm = () => {
    setAccount({
      email: "",
      password: "",
      cpassword: "",
      firstname: "",
    });
    setError(false);
  };

  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-12">
          <h3>Créer son compte</h3>
        </div>
      </div>
      <div className="row my-4">
        <div className="col-12 col-md-8 col-lg-6">
          <form>
            <div className="form-group">
              <label>Pseudo</label>
              <input
                className="form-control"
                type="text"
                name="firstname"
                value={account.firstname}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                className="form-control"
                type="email"
                name="email"
                value={account.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Mot de passe</label>
              <input
                className="form-control"
                type="password"
                name="password"
                value={account.password}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Confirmer le mot de passe</label>
              <input
                className="form-control"
                type="password"
                name="cpassword"
                value={account.cpassword}
                onChange={handleChange}
              />
            </div>

            <p className="text-danger small mt-2">
              {error &&
                "Erreur. Veuillez compléter ou modifier le formulaire en vérifiant vos informations"}
            </p>

            <div className="row">
              <div className="col-md-5 mr-3">
                <button
                  type="button"
                  className="btn btn-danger w-100"
                  onClick={handleResetForm}
                >
                  Effacer
                </button>
              </div>
              <div className="col-md-5">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={handleSubmit}
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
